export enum RequestKeys {
    REGION_IDS = 'regionIds',
    SETTLEMENT_IDS = 'settlementIds',  
    REGIONS = 'regions',
    THESAURUS_WIDS = 'thesaurusWids',
    ADVANCED_THESAURUS = 'advancedThesaurus',
    PERSONS = 'persons',
    FREE_TEXT = 'freeText',
    LICENSES = 'licenses',
    EXPEDITIONS = 'expeditions',
    EXPEDITION_LICENSES = 'expeditionLicenses',
    EXCAVATIONS = 'excavations',
    CONSERVATION_REPORTS = 'conservationReports',
    EXCAVATION_LICENSES = 'excavationLicenses',
    SURVEYS = 'surveys',
    SURVEY_LICENSES = 'surveyLicenses',
    ENTITY_TYPES = 'entityTypes',
    PERIOD_MIDS = 'periodMids',
    FIND_TYPE_MIDS = 'findTypeMids',
    MATERIAL_MIDS = 'materialMids',
    HACHRAZOT = 'hachrazot',
    HERITAGE_SITE_IDS = 'heritageSiteIds'  }